import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const AgendaScreen = lazy(() => import('../screens/AgendaScreen.js'));

/** Agenda de l'atelier (vague 7, module facultatif). */
export default function AgendaPage() {
  return (
    <GarageGate>
      <AgendaScreen />
    </GarageGate>
  );
}
